/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from "@angular/core";
import { BaseDataService } from "../core/base.dataservice";
import service = require("./breeze.entitymanager.service");
import { ServiceConfig } from "../core/core.constants";

// Angular 1
export function initialize(module: ng.IModule) {
    module.service(WorkSchedulesDataService.Id, WorkSchedulesDataService);

    WorkSchedulesDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

// Angular 2+
@Injectable()
export class WorkSchedulesDataService extends BaseDataService<Nema.Crew.Model.WorkSchedule> {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "workScheduleDataService";

    public get EntityName(): string {
        return "WorkSchedule";
    }

    public get EntitiesName(): string {
        return "WorkSchedules";
    }

    public deleteRelatedEntities(entity: Nema.Crew.Model.WorkSchedule): Promise<void> {
        entity.Steps.forEach(step => (<breeze.Entity><any>step).entityAspect.entityState = this.breeze.EntityState.Deleted);
        var deleteRelations = this.entityManager.saveChanges();

        return <Promise<void>><any>deleteRelations;
    }

    public newWorkScheduleStep(defaultActivityTypeId: number): Nema.Crew.Model.WorkScheduleStep {
        return <Nema.Crew.Model.WorkScheduleStep><any>this.entityManager.createEntity('WorkScheduleStep', <Nema.Crew.Model.WorkScheduleStep>{
            Active: true,
            ActivityTypeId: defaultActivityTypeId,
            DurationInDays: 1,
            CreatedDate: new Date(),
            CreatedBy: ServiceConfig.loggedInUser
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/workschedules.dataservice.ts